import {
  sendTemplatedEmailToUserV2,
  sendTemplatedEmailV1,
  type SendTemplatedEmailPayload,
  type SendTemplatedEmailToUserPayload,
} from "@/lib/data/requests/contacts/contact-templated-email";
import type { APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import toast from "react-hot-toast";

export const useSendTemplatedEmail = () => {
  return useMutation({
    mutationFn: (payload: SendTemplatedEmailPayload) =>
      sendTemplatedEmailV1(payload),
    onSuccess: () => {
      toast.success("Email sent successfully");
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Failed to send email");
    },
  });
};

export const useSendTemplatedEmailToUser = () => {
  return useMutation({
    mutationFn: (payload: SendTemplatedEmailToUserPayload) =>
      sendTemplatedEmailToUserV2(payload),
    onSuccess: () => {
      toast.success("Email sent successfully");
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Failed to send email");
    },
  });
};
